// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_fu5Xe","foot_link":"index_foot_link_tSw1v","list":"index_list_cE-mD","link":"index_link_4l22l","copyright":"index_copyright_m2B5R"};